import styled, { css, keyframes } from 'styled-components'

const Loading = () => (
  <div>
    <Spinner />
  </div>
)

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  ${({ theme }) => css`
    border: 8px solid transparent;
    border-left-color: ${theme.colors.primary};
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin: auto;
    animation: ${rotate} 1s linear infinite;
  `}
`

export default Loading
